import { render, staticRenderFns } from "./EmailTemplateBoostList.vue?vue&type=template&id=000cbecb&scoped=true&"
import script from "./EmailTemplateBoostList.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateBoostList.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateBoostList.vue?vue&type=style&index=0&id=000cbecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000cbecb",
  null
  
)

export default component.exports